module.exports = __webpack_public_path__ + "img/primary_1x4_z16.ac075368.svg";